export default {
  loadingText: {
    id: 'bo_seller.listing.product_create.details.loading_text',
    defaultMessage: 'Loading...',
  },
  required: {
    id: 'bo_seller.listing.product_create.details.required',
    defaultMessage: 'Required',
  },
  fieldIsRequired: {
    id: 'bo_seller.listing.product_create.details.field_is_required',
    defaultMessage: 'This field is required',
  },
  nextStep: {
    id: 'bo_seller.listing.product_create.details.next_step',
    defaultMessage: 'Next',
  },
  mainImageUrl: {
    id: 'bo_seller.listing.product_create.details.main_image_url',
    defaultMessage: 'Main Image URL',
  },
  urlImage2: {
    id: 'bo_seller.listing.product_create.details.url_image_2',
    defaultMessage: 'URL image 2',
  },
  urlImage3: {
    id: 'bo_seller.listing.product_create.details.url_image_3',
    defaultMessage: 'URL image 3',
  },
  urlImage4: {
    id: 'bo_seller.listing.product_create.details.url_image_4',
    defaultMessage: 'URL image 4',
  },
  urlImage5: {
    id: 'bo_seller.listing.product_create.details.url_image_5',
    defaultMessage: 'URL image 5',
  },
  urlImage6: {
    id: 'bo_seller.listing.product_create.details.url_image_6',
    defaultMessage: 'URL image 6',
  },
}
